<template>
  <CommonHeader
    class="nps-header"
    title="Statistiques des notes NPS"
    description="Retrouvez l'ensemble des notes NPS attribuées par les bénéficiaires."
  >
    <template #action>
      <CommonButton dashed color="dark" icon="Download" @click="nps_store.exportCsv(search, sort)">
        Télécharger le tableau
      </CommonButton>
    </template>
  </CommonHeader>
  <LayoutContainer>
    <div class="nps-stats">
      <CompositeNpsList
        :items="nps_store.results"
        :loading="nps_store.loadingResults"
        @search="onSearch"
        @open="openDetail"
      >
        <template #filters>
          <InputSelect
            id="nps-sort"
            class="sort"
            label="Trier par"
            placeholder="Plus récentes"
            :options="sortOptions"
            :model-value="sort"
            @update:model-value="onSort"
          />
        </template>
      </CompositeNpsList>
      <CommonPagination
        :page="page"
        :total-items="nps_store.totalItems"
        :items-per-page="ITEMS_PER_PAGE"
        @update:page="onPage"
      />
    </div>
  </LayoutContainer>
  <ModalNpsDetail ref="modal" />
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import CommonButton from '@/components/common/CommonButton.vue'
import CommonHeader from '@/components/common/CommonHeader.vue'
import CommonPagination from '@/components/common/CommonPagination.vue'
import InputSelect from '@/components/common/input/InputSelect.vue'
import LayoutContainer from '@/components/layout/LayoutContainer.vue'
import CompositeNpsList from '@/components/composite/nps/CompositeNpsList.vue'
import ModalNpsDetail from '@/components/composite/modal/ModalNpsDetail.vue'
import { useNpsStore } from '@/stores/gae/store_nps'

const ITEMS_PER_PAGE = 20

const sortOptions: SelectOption[] = [
  { label: 'Par date', value: 'date' },
  { label: 'De A à Z', value: 'provider_asc' },
  { label: 'De Z à A', value: 'provider_desc' },
  { label: 'De 0 à 10', value: 'score_asc' },
  { label: 'De 10 à 0', value: 'score_desc' }
]

const nps_store = useNpsStore()
const modal = ref<InstanceType<typeof ModalNpsDetail>>()
const page = ref(1)
const search = ref('')
const sort = ref('date')

onMounted(fetch)

function fetch() {
  nps_store.fetchResults({
    page: page.value,
    itemsPerPage: ITEMS_PER_PAGE,
    search: search.value,
    sort: sort.value
  })
}

function onSearch(value: string) {
  search.value = value
  page.value = 1
  fetch()
}

function onSort(value: string) {
  sort.value = value || 'date'
  page.value = 1
  fetch()
}

function onPage(value: number) {
  page.value = value
  fetch()
}

function openDetail(interventionId: number) {
  nps_store.fetchDetail(interventionId).then(() => modal.value?.open())
}
</script>

<style scoped lang="scss">
.nps-stats {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

@media screen and (min-width: 640px) {
  .nps-header :deep(.action) {
    left: auto;
    right: 50px;
  }
}

.sort {
  min-width: 220px;
}
</style>
